<div class="bibleModal__content">
    <ion-row class="ion-align-items-center">
        <ion-col size="9">
            <h4 class="heading4" style="margin-top: 0;">{{'ShareWithOthers' | translation}}</h4>
        </ion-col>
        <ion-col size="3" class="ion-text-right">
            <ion-icon (click)="dismiss()" name="close" class="cursor-pointer" style="margin-right: -4px;"></ion-icon>
        </ion-col>
    </ion-row>
    <ion-list lines="none" class="location-list">
        <ion-item class="ion-margin-bottom" button  *ngFor="let contact of Contacts">
            <!-- <ion-icon name="logo-facebook" slot="start" style="margin-right: 10px;"></ion-icon> -->
            <ion-label> 
                {{contact.first_name }} {{contact.last_name}}
            </ion-label>
            <ion-checkbox slot="end" [(ngModel)]="contact.isChecked"  (ngModelChange)="getSelectedContacts($event,contact)" ></ion-checkbox>
 
        </ion-item>
        <ion-button (click)="SendVerse()">{{ 'Share' | translation }}</ion-button>
    </ion-list>
</div>
